























import VuFormTypeaheadAbstract from './VuFormTypeaheadAbstract.vue';

export {default as VuFormTypeaheadTemplate} from './VuFormTypeaheadTemplate.vue';
export {default as VuFormTypeaheadAbstract} from './VuFormTypeaheadAbstract.vue';

export default {
    name: 'VuFormTypeahead',
    extends: VuFormTypeaheadAbstract
};
